function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYzllink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1428px",
    height: "1428px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#3069aa",
    d: "M 1427.5,825.5 C 1427.5,864.167 1427.5,902.833 1427.5,941.5C 1402.95,1047.1 1340.28,1119.93 1239.5,1160C 1212.62,1169.51 1184.96,1175.18 1156.5,1177C 1019.83,1177.5 883.167,1177.67 746.5,1177.5C 746.672,1176.51 746.338,1175.84 745.5,1175.5C 740.932,1166.7 736.099,1158.03 731,1149.5C 723.059,1132.74 718.392,1115.07 717,1096.5C 715.075,1073.54 714.242,1050.54 714.5,1027.5C 715.441,974.835 715.607,922.168 715,869.5C 707.684,814.856 678.184,778.022 626.5,759C 601.061,750.89 575.061,748.39 548.5,751.5C 568.351,778.222 580.184,808.222 584,841.5C 586.47,870.78 587.137,900.113 586,929.5C 583.399,963.808 581.233,998.141 579.5,1032.5C 578.263,1068.98 590.263,1100.15 615.5,1126C 638.803,1145.32 663.803,1162.15 690.5,1176.5C 690.5,1176.83 690.5,1177.17 690.5,1177.5C 548.65,1177.45 406.817,1177.45 265,1177.5C 178.304,1175.32 107.97,1140.65 54,1073.5C 22.1361,1031.08 3.96945,983.411 -0.5,930.5C -0.5,917.5 -0.5,904.5 -0.5,891.5C 9.06426,799.836 52.7309,729.669 130.5,681C 141.897,674.635 153.563,668.802 165.5,663.5C 140.99,605.159 143.156,547.826 172,491.5C 213.895,422.628 275.395,390.128 356.5,394C 410.389,399.439 454.389,422.939 488.5,464.5C 525.135,347.032 600.468,265.199 714.5,219C 822.257,180.897 926.59,188.564 1027.5,242C 1132.05,303.317 1194.22,394.15 1214,514.5C 1217.54,543.085 1218.37,571.752 1216.5,600.5C 1295.52,622.695 1355.35,669.362 1396,740.5C 1410.59,767.434 1421.09,795.767 1427.5,825.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a2aed3",
    d: "M 875.5,746.5 C 874.833,747.167 874.167,747.833 873.5,748.5C 873.281,747.325 873.614,746.325 874.5,745.5C 875.107,745.624 875.44,745.957 875.5,746.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 875.5,746.5 C 898.835,767.82 915.669,793.487 926,823.5C 935.085,858.5 929.752,891.166 910,921.5C 904.382,929.453 898.382,937.12 892,944.5C 843.725,990.107 796.058,1036.44 749,1083.5C 748.333,1031.83 748.333,980.167 749,928.5C 750.763,919.309 754.43,910.975 760,903.5C 769.393,891.101 779.893,879.601 791.5,869C 802.833,859.667 814.167,850.333 825.5,841C 851.918,815.667 867.918,784.833 873.5,748.5C 874.167,747.833 874.833,747.167 875.5,746.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 745.5,1175.5 C 727.341,1176.5 709.008,1176.83 690.5,1176.5C 663.803,1162.15 638.803,1145.32 615.5,1126C 590.263,1100.15 578.263,1068.98 579.5,1032.5C 581.233,998.141 583.399,963.808 586,929.5C 587.137,900.113 586.47,870.78 584,841.5C 580.184,808.222 568.351,778.222 548.5,751.5C 575.061,748.39 601.061,750.89 626.5,759C 678.184,778.022 707.684,814.856 715,869.5C 715.607,922.168 715.441,974.835 714.5,1027.5C 714.242,1050.54 715.075,1073.54 717,1096.5C 718.392,1115.07 723.059,1132.74 731,1149.5C 736.099,1158.03 740.932,1166.7 745.5,1175.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.753
    },
    fill: "#bfc7e0",
    d: "M 745.5,1175.5 C 746.338,1175.84 746.672,1176.51 746.5,1177.5C 727.833,1177.5 709.167,1177.5 690.5,1177.5C 690.5,1177.17 690.5,1176.83 690.5,1176.5C 709.008,1176.83 727.341,1176.5 745.5,1175.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYzllink);
export default __webpack_public_path__ + "static/media/yzllink.73132af07260b1ce082edd91ffc3d1cb.svg";
export { ForwardRef as ReactComponent };